import React from 'react'
import PropTypes from 'prop-types'
import { Item } from '.'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const ShippingValue = ({ price }) => {
  return (
    <Item
      description='Frete:'
      className='row product-brand py-2 px-2 border-dotted-bottom border-color-ui-3'
      classFont='txt-body-sm color-ui-2'
    >
      {price.points || price.cash ? (
        <CatalogCurrencyLabel price={price} checkCashOnly />
      ) : (
        <strong>...</strong>
      )}
    </Item>
  )
}

ShippingValue.propTypes = {
  price: PropTypes.object.isRequired
}

export default ShippingValue



// WEBPACK FOOTER //
// ./src/features/SummaryOrder/ShippingValue.js